<template>
  <div class="essenza-product-box">
    <div v-if="attributes">
      <div v-for="(options, attributeName) in attributes" :key="attributeName">
        <h4>{{ attributeName }}</h4>
        <ComboPicker
          :options="options"
          v-model="selectedAttributes[attributeName]"
          option-key="name" 
        />
        <p v-if="selectedAttributes[attributeName]">Selected: {{ selectedAttributes[attributeName] }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import ComboPicker from './controls/ComboPicker.vue';

export default {
  components: {
    ComboPicker
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    defaultVariation: {
      type: Object,
      required: false
    },
    variations: {
      type: Array,
      required: false
    },
    attributes: {
      type: Object,
      required: false
    },
    isVariable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selectedAttributes: {}
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.essenza-product-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
